import React, { PureComponent } from 'react';
import styled from 'styled-components';
const Form = styled.form`
width: 100%;
`
const Fieldset = styled.fieldset`
  width: ${(props) => props.width || "50%"};
  height: ${(props) => props.height || "44px"};
  padding-left: ${(props) => props.paddingLeft || "10%"};
  padding-Right: ${(props) => props.paddingRight || "10%"};
  margin-bottom: 17px;
`;
const Input = styled.input`
cursor: text;
width: 100%;
height:100%;
background: #F6F6F6;
border-radius: 5px;
text-align: center;
line-height: 44px;
font-size: 16px;
font-weight: 500;
outline: none;
&::placeholder {
  color : rgba(183,183,183,1)
}
`

const Div = styled.div`
display: flex;
flex-wrap: wrap;
position:relative;
`
const Htwo = styled.h2`
  color: #000;
  padding: 0 10%;
  font-size: 25px;
  line-height: 43px;
`;
const Textarea = styled.textarea`
  width: 100%;
  height: 100%;
  padding-left: 15px;
  padding-top: 10px;
  resize: none;
  background: #f6f6f6;
  font-size: 20px;
  border-radius: 5px;
  font-weight: 500;
  padding-left: 15px;
  padding-top: 10px;
  outline: none;
  &::placeholder {
    color: rgba(183, 183, 183, 1);
    text-align: center;
    line-height: 240px;
  }
`;
const Button = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: url(../images/send.png) center no-repeat;
  background-color: rgba(255, 176, 57, 1);
  box-shadow: 10px 20px 50px rgb(255 176 57 / 60%);
  float: right;
  transform: translate(-50%, -150%);
  ${({ theme }) => theme.media.tablet`
  margin-left: 78%;
    `}
  ${({ theme }) => theme.media.mobile`
    `}
`;
const DivOuter = styled.div`
display: flex;
`

const LecDiv = styled.div`
  width: 77px;
  height: 29px;
  background: #3f3c3c;
  border-radius: 3px;
  line-height: 29px;
  text-align: center;
  float: right;
  -webkit-transform: translate(48%, -395%);
  -ms-transform: translate(48%, -395%);
  transform: translate(48%, -395%);
  pointer-events: none;
  ${({ theme }) => theme.media.tablet`
  -webkit-transform: translate(-14%, -570%);
  -ms-transform: translate(-14%, -570%);
  transform: translate(-14%, -570%);
    `}
`;
const TriDiv = styled.div`
  width: 19px;
  height: 12px;
  background: url(../images/arrow.png) no-repeat;
  border-radius: 1px;
  float: right;
  -webkit-transform: translate(462%, -740%);
  -ms-transform: translate(462%, -740%);
  transform: translate(462%, -740%);
  pointer-events: none;
  ${({ theme }) => theme.media.tablet`
  -webkit-transform: translate(216%, -1152%);
  -ms-transform: translate(216%, -1152%);
  transform: translate(216%, -1152%);
    `}
`;


function submit_hover () {
  var submit = document.querySelector(".submit_hover");
  submit.style.display = 'block';
}
function submit_unhover () {
  var submit = document.querySelector(".submit_hover");
  submit.style.display = 'none';
}

class FormAtom extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (
      <DivOuter>
        <Form
          className="gform"
          method="POST"
          data-email="example@email.net"
          action="https://script.google.com/macros/s/AKfycbyWD6HOnWeaG9u4OZKXB0j9jBSnoErsia6_oQzFlEEegMZZzGA/exec"
        >
          <Div className="form-elements">
            <Fieldset paddingRight="1%">
              <Input
                id="name"
                name="name"
                autocomplete="false"
                placeholder="성함을 입력해주세요."
              />
            </Fieldset>
            <Fieldset paddingLeft="1%" paddingRight="10%">
              <Input
                id="phone"
                name="phone"
                autocomplete="off"
                placeholder="연락처를 입력해주세요."
              />
            </Fieldset>
            <Fieldset width="100%">
              <Input
                id="email"
                name="email"
                type="email"
                autocomplete="off"
                required
                placeholder="이메일을 입력해주세요."
              ></Input>
            </Fieldset>
            <Fieldset width="100%" height="240px">
              <Textarea
                id="message"
                name="message"
                autocomplete="off"
                rows="10"
                required
                placeholder="메세지를 입력해주세요."
              ></Textarea>
              <Button className="submit" onMouseOver={submit_hover} onMouseOut={submit_unhover}></Button>
              <div style={{ display: "none" }} className="submit_hover">
                <LecDiv>보내기</LecDiv>
                <TriDiv></TriDiv>
              </div>
            </Fieldset>
          </Div>
          <div style={{ display: "none" }} className="thankyou_message">
            <Htwo>
              문의 주셔서 감사합니다. <br /> 곧 연락 드리겠습니다 :)
            </Htwo>
          </div>
        </Form>
      </DivOuter>
    );
  }
}



export default FormAtom;















